module.exports = __webpack_public_path__ + "img/phone-screen-en.54089a5e.png";